export default __webpack_public_path__ + "static/media/Warmonger Ring.f83d2ab5.jpg";